import { commonServerInstance } from '@/utilities/instances'

export const generateInvoiceNumber = async (params: {
  customer_id: number | undefined
  description: string
  custom_company: string
}) => {
  const response = await commonServerInstance.post(
    'settlement/generate-invoice-number',
    {
      ...params
    }
  )
  return response?.data?.data
}

export const getCustomers = async () => {
  const response = await commonServerInstance.get('settlement/unicustomers', {})
  return response?.data?.data
}
